import { Button } from '@/app/common/components/button/Button'
import React from 'react'

export default function FormButtons({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="flex items-center justify-end space-x-2">{children}</div>
  )
}

function NextButton({
  onClick,
  type = 'button',
  disabled = false,
}: {
  onClick?: () => void
  type?: 'button' | 'submit'
  disabled?: boolean
}) {
  return (
    <Button variant="primary" onClick={onClick} type={type} disabled={disabled}>
      Next
    </Button>
  )
}

function BackButton({
  onClick,
  buttonText = 'Back',
}: {
  onClick: () => void
  buttonText?: string
}) {
  return (
    <Button variant="outline" onClick={onClick}>
      {buttonText}
    </Button>
  )
}

FormButtons.NextButton = NextButton
FormButtons.BackButton = BackButton
